import React from 'react';
import PropTypes from 'prop-types';
import {getLayoutMode, getGroupsForTrends} from 'common/utils/chart-util';
import Card from 'common/components/card';
import CardContent from 'common/components/card-content';
import CardHeader from 'common/components/card-header';
import CardCallouts from 'common/components/card-callouts';
import TrendsChart from 'common/components/trends-chart';
import {t} from 'common/utils/translation-util';
import './index.scss';

/**
 * TrendsCard is a wrapper around the TrendsChart component.
 * It parses a report into groups that the chart accepts.
 */
export default class TrendsCard extends React.Component {
  static propTypes = {
    animate: PropTypes.bool,
    connectDragSource: PropTypes.func,
    disableConfig: PropTypes.bool,
    report: PropTypes.object.isRequired,
  };

  static defaultProps = {
    animate: false,
    disableConfig: false,
  };

  getFilteredData(data) {
    return data.filter((datum) => datum.value !== null);
  }

  getCardContentClassName(header) {
    const classNames = [];
    const {meta} = this.props.report;
    const hasNoCallouts =
      meta && meta.dataSummary && meta.dataSummary.length === 0;
    if (hasNoCallouts) {
      classNames.push('CardContent--no-callouts');
    }
    if (!header) {
      classNames.push('CardContent--no-header');
    }
    return classNames.join(' ');
  }

  shouldShowError(data) {
    return data.length < 1;
  }

  render() {
    const meta = this.props.report.meta;

    const filteredData = this.getFilteredData(this.props.report.data);
    const shouldShowError = this.shouldShowError(filteredData);
    const header = (this.props.connectDragSource || ((x) => x))(
      <div>
        <CardHeader
          dataManagerUrl={meta.dataManagerUrl}
          disableConfig={this.props.disableConfig}
          priorityWarnings={this.props.report.priorityWarnings}
          reportId={this.props.report.id}
          scheduleId={this.props.report.scheduleId}
          subtitle={meta.subtitle || meta.period.displayName}
          title={this.props.report.name}
          warnings={this.props.report.warnings}
        />
      </div>,
    );

    const cardContentClassName = this.getCardContentClassName(header);
    const groups = getGroupsForTrends(this.props.report);
    const layoutMode = getLayoutMode(groups);
    return (
      <Card className={'TrendsCard'}>
        {header}
        <CardContent
          className={cardContentClassName}
          errorMessage={t('No data to display.')}
          showError={shouldShowError}>
          <TrendsChart
            groups={groups}
            gutters={{
              bottom: 18,
              left: 30,
              right: 30,
              top: 18,
            }}
            layoutMode={layoutMode}
          />
          <CardCallouts meta={meta} />
        </CardContent>
      </Card>
    );
  }
}
